'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentEthereumAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.4666 7.51343L41.1725 8.51605V37.6098L41.4666 37.9043L54.9333 29.9215L41.4666 7.51343Z",
          fill: "#343434"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.4667 7.51343L28 29.9215L41.4667 37.9044V23.7831V7.51343Z",
          fill: "#8C8C8C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.4666 40.4614L41.3009 40.664V51.0279L41.4666 51.5134L54.9413 32.4826L41.4666 40.4614Z",
          fill: "#3C3C3B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.4667 51.5133V40.4613L28 32.4825L41.4667 51.5133Z",
          fill: "#8C8C8C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M41.4666 37.9042L54.9331 29.9216L41.4666 23.7832V37.9042Z",
          fill: "#141414"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28.0001 29.9216L41.4666 37.9043V23.7833L28.0001 29.9216Z",
          fill: "#393939"
        }
      )
    ]
  }
);
const VpPaymentEthereumAsset = forwardRef(PaymentEthereumAsset);

export { VpPaymentEthereumAsset as default };
